// extracted by mini-css-extract-plugin
export var avatar = "_rh-3";
export var avatarContainer = "_rh-2";
export var avatarSpacer = "_rh-5";
export var avatarSpacerContainer = "_rh-4";
export var avatarStackContainer = "_rh-1";
export var bubble = "_rh-0";
export var remainderBubble = "_rh-6";